import { ClientePolicy } from "./ClientePolicy";

export const clientePolicy = new ClientePolicy()